<div id="viewpublicsite" class="publicsite-container">
  <div class="publicsite-header">
      <span>Click on client to navigate</span>
  </div>
  <div class="publicsite-table">
    <mat-table id="clientstable"  [dataSource]="dataSource" #sort="matSort" matSort>
        
        <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef>Client</mat-header-cell>
            <mat-cell *matCellDef="let client"><a (click)="openClientPage(client.code)" style="cursor: pointer;">{{client.code}}</a></mat-cell>
        </ng-container>            
        
        <mat-header-row *matHeaderRowDef="columnDef"></mat-header-row>
      
        <mat-row *matRowDef="let row; columns: columnDef"></mat-row>

    </mat-table>
  </div>

</div>